import cx from 'classnames';
import { GatsbyImage, IGatsbyImageData } from 'gatsby-plugin-image';
import React from 'react';

import * as styles from './Image.module.css';

const Image = ({
	image,
	alt,
	width,
	height,
	fit = 'cover',
	lazy = 'lazy',
	as: Component = 'div',
	className = '',
}: {
	image: IGatsbyImageData | string;
	alt: string;
	width?: string;
	height?: string;
	fit?: 'cover' | 'contain';
	lazy?: 'lazy' | 'eager';
	as?: React.ElementType;
	className?: string;
}) => {
	// TO DO - Fix this once the Storyblok localAssets is resolved.
	const isDynamicImage = typeof image === 'object';

	return (
		<Component
			className={cx(styles.image, styles[`${fit}Fit`], className)}
			style={{ width: width, height: height }}
		>
			{isDynamicImage ? (
				<GatsbyImage image={image} alt={alt} objectFit={fit} lazy={lazy} />
			) : (
				<img src={image} alt={alt} />
			)}
		</Component>
	);
};

export default Image;
